/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ScanningInputs */

const en_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const fr_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balayage...`)
};

const de_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanvorgang läuft...`)
};

const it_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansione in corso...`)
};

const ru_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование...`)
};

const es_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exploración...`)
};

const zh_cn2_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描...`)
};

const ja_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`走査...`)
};

const hi_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कैनिंग जारी है...`)
};

const pt_pt2_audio_embed_export_scanning = /** @type {(inputs: Audio_Embed_Export_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisando...`)
};

/**
* | output |
* | --- |
* | "Scanning..." |
*
* @param {Audio_Embed_Export_ScanningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scanning = /** @type {((inputs?: Audio_Embed_Export_ScanningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ScanningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_scanning(inputs)
	if (locale === "de") return de_audio_embed_export_scanning(inputs)
	if (locale === "it") return it_audio_embed_export_scanning(inputs)
	if (locale === "ru") return ru_audio_embed_export_scanning(inputs)
	if (locale === "es") return es_audio_embed_export_scanning(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_scanning(inputs)
	if (locale === "ja") return ja_audio_embed_export_scanning(inputs)
	if (locale === "hi") return hi_audio_embed_export_scanning(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_scanning(inputs)
	return en_audio_embed_export_scanning(inputs)
});